"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var withContext_1 = require("../../utils/hoc/withContext");
var UnmanagedModalWithinContext_1 = require("./UnmanagedModalWithinContext");
/**
 * This is the unmanaged variant of the [Modal](#!/Modal) component.
 *
 * The `Modal` component manages all modal states.
 * If you want to control the modal states yourself, you can use this component.
 *
 * A detailled props description to the Modal component can be found in the
 * [UnmanagedModalWithinContext](#!/UnmanagedModalWithinContext) component.
 */
exports.Modal = withContext_1.withErgoElementsContext('UnmanagedModal', UnmanagedModalWithinContext_1.UnmanagedModalWithinContext);
exports.default = exports.Modal;
__export(require("./UnmanagedModalWithinContext"));
//# sourceMappingURL=Modal.js.map
